import {Area, BeaconTrigger, Spot, Zone} from "../types";

const hasIosReadableBeacon = (beacons?: BeaconTrigger[]): boolean =>
    !!beacons && beacons.some((b) => b.type === "iBeacon");

const hasMacOnlyBeacon = (beacons?: BeaconTrigger[]): boolean =>
    !!beacons && beacons.some((b) => b.type === "Beacon");

export const isSpotIosCompatible = (spot: Spot): boolean => {
    if (!hasMacOnlyBeacon(spot.beaconTriggers)) {
        return true;
    }
    if (hasIosReadableBeacon(spot.beaconTriggers)) {
        return true;
    }
    if (spot.wiFiTriggers && spot.wiFiTriggers.length > 0) {
        return true;
    }
    if (spot.gpsTriggers && spot.gpsTriggers.length > 0) {
        return true;
    }
    return false;
};

export const isZoneIosCompatible = (zone: Zone): boolean => {
    if (!hasMacOnlyBeacon(zone.beaconTriggers)) {
        return true;
    }
    if (hasIosReadableBeacon(zone.beaconTriggers)) {
        return true;
    }
    if (zone.wiFiTriggers && zone.wiFiTriggers.length > 0) {
        return true;
    }
    if (zone.gpsTriggers && zone.gpsTriggers.length > 0) {
        return true;
    }
    return false;
};

const collectAreaZones = (area: Area): Zone[] => {
    const zones = area.zones;
    if (!zones) {
        return [];
    }
    const out: Zone[] = [];
    if (zones.boundaries) out.push(zones.boundaries);
    if (zones.entry) out.push(zones.entry);
    if (zones.exit) out.push(zones.exit);
    if (zones.maintenance) out.push(zones.maintenance);
    if (Array.isArray(zones.ambientZones)) out.push(...zones.ambientZones);
    return out;
};

export const computeAreaIosCompatibility = (area: Area, spots: Spot[]): boolean => {
    const start = performance.now();
    let compatible = true;
    for (const spot of spots) {
        if (!isSpotIosCompatible(spot)) {
            compatible = false;
            break;
        }
    }
    if (compatible) {
        for (const zone of collectAreaZones(area)) {
            if (!isZoneIosCompatible(zone)) {
                compatible = false;
                break;
            }
        }
    }
    const elapsed = performance.now() - start;
    console.log(`[iosCompatibility] sweep took ${elapsed.toFixed(2)}ms (${spots.length} spots, area=${area.id}) → ${compatible}`);
    return compatible;
};
